import { render, staticRenderFns } from "./BulkItemCreateOrUpdate.vue?vue&type=template&id=5ce68200&scoped=true&"
import script from "./BulkItemCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./BulkItemCreateOrUpdate.vue?vue&type=script&lang=js&"
import style0 from "./BulkItemCreateOrUpdate.vue?vue&type=style&index=0&id=5ce68200&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce68200",
  null
  
)

export default component.exports